import { api } from '@/lib/api/client'

export type VoucherType = 'PERCENT' | 'FIXED'

export interface Voucher {
  id: string
  code: string
  description: string
  type: VoucherType
  value: number
  minOrder: number
  maxDiscount: number
  usageLimit: number
  usedCount: number
  startAt: string
  endAt: string | null
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateVoucherInput {
  code: string
  description?: string
  type?: VoucherType
  value: number
  minOrder?: number
  maxDiscount?: number
  usageLimit?: number
  startAt?: string
  endAt?: string | null
  active?: boolean
}
export type UpdateVoucherInput = Partial<CreateVoucherInput>

export interface ApplyResult {
  code: string
  discount: number
  description: string
  type: VoucherType
  value: number
}

export const vouchersApi = {
  listActive: ()                    => api.get<Voucher[]>('/vouchers'),
  apply:      (code: string, subtotal: number) => api.post<ApplyResult>('/vouchers/apply', { code, subtotal }),
  adminList:  ()                    => api.get<Voucher[]>('/admin/vouchers'),
  adminOne:   (id: string)          => api.get<Voucher>(`/admin/vouchers/${id}`),
  adminCreate:(p: CreateVoucherInput)=> api.post<Voucher>('/admin/vouchers', p),
  adminUpdate:(id: string, p: UpdateVoucherInput) => api.patch<Voucher>(`/admin/vouchers/${id}`, p),
  adminDelete:(id: string)          => api.delete<{ ok: boolean }>(`/admin/vouchers/${id}`),
}
